export default __webpack_public_path__ + "static/media/8-shine.67dcd76c.png";